import { render, staticRenderFns } from "./agenda_docente.vue?vue&type=template&id=65df09d0"
import script from "./agenda_docente.vue?vue&type=script&lang=js"
export * from "./agenda_docente.vue?vue&type=script&lang=js"
import style0 from "./agenda_docente.vue?vue&type=style&index=0&id=65df09d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports